import { memo } from 'react'
import { useTranslation } from 'services/Translation'

import Header from './Header'
import Tabs from './Tabs'

const texts = (getText) => (key) =>
  ({
    title: getText('My Account', 'Account_Content'),
  }[key])

const AccountContent = () => {
  const { t } = useTranslation(texts)

  return (
    // Bump the shared horizontal padding so the account content clears the
    // fixed "power off" logout button pinned to the left edge (60px wide at
    // 75% viewport height). Applied on the wrapper so the header, tab header
    // and tab content stay aligned while their full-width backgrounds are kept.
    <div style={{ marginTop: '6.375rem', '--dashboard-padding-x': '4.5rem' }}>
      <Header />
      <Tabs />
    </div>
  )
}

AccountContent.whyDidYouRender = true

export default memo(AccountContent)